import { http } from '../api/http';

export type DevelopmentDocument = {
  id: number;
  development_id: number;
  title: string;
  file_url: string;
  sort_order: number;
};

export type CreateDocumentPayload = {
  title: string;
  file_url: string;
  sort_order?: number;
};

export const DevelopmentDocumentsService = {
  list(developmentId: number | string) {
    return http<{ ok: boolean; data: DevelopmentDocument[] }>(`/admin/developments/${developmentId}/documents`);
  },

  create(developmentId: number | string, payload: CreateDocumentPayload) {
    return http<{ ok: boolean; data: DevelopmentDocument }>(`/admin/developments/${developmentId}/documents`, {
      method: 'POST',
      body: payload
    });
  },

  remove(developmentId: number | string, documentId: number | string) {
    return http<{ ok: boolean }>(`/admin/developments/${developmentId}/documents/${documentId}`, {
      method: 'DELETE'
    });
  }
};
